import HelpLinksPage from '@/pages/setup/link_handlers/help_links/Page.tsx'
import HandbookLinkPage from '@/pages/setup/link_handlers/handbook_link/Page.tsx'
import WalletHandbookLinkPage from '@/pages/setup/link_handlers/wallet_handbook_link/Page.tsx'

const LinkHandlersPage = () => {
  return (
    <div>
      <HelpLinksPage />
      <HandbookLinkPage />
      <WalletHandbookLinkPage />
    </div>
  )
}
export default LinkHandlersPage
